module.exports = __webpack_public_path__ + "img/logo-aef-info.ac1869a4.svg";